/**
 * ファイルステータス
 */
const FileStatusCode = {
  /** 初期状態 */
  INITIAL_STATE: '0',
  /** スケジュール済み */
  SCHEDULED: '1',
  /** SDF取り込み待ち */
  SDF_BEING_IMPORTED: '2',
  /** SDF取り込みエラー */
  SDF_IMPORT_ERROR: '3',
  /** SDF取り込み中 */
  SDF_CHECKING: '4',
  /** システムエラー */
  SYSTEM_ERROR: '6',
  /** 完了 */
  COMPLETED: '7',
  /** 法規制チェック実施待ち */
  REG_CHECK_RESERVED: '8',
  /** 法規制チェック中 */
  REG_CHECKING: '9',
  /** 法規制チェックエラー */
  REG_CHECK_ERROR: 'E',
} as const;

type FileStatusCode = typeof FileStatusCode[keyof typeof FileStatusCode];

/**
 * コード名称取得
 * @param code ファイルステータスコード
 * @return コード名称
 */
export function getName(code: FileStatusCode) {
  switch (code) {
    case FileStatusCode.INITIAL_STATE:
      return '初期状態';
    case FileStatusCode.SCHEDULED:
      return 'スケジュール済み';
    case FileStatusCode.SDF_BEING_IMPORTED:
      return 'SDF取り込み待ち';
    case FileStatusCode.SDF_IMPORT_ERROR:
      return 'SDF取り込みエラー';
    case FileStatusCode.SDF_CHECKING:
      return 'SDF取り込み中';
    case FileStatusCode.SYSTEM_ERROR:
      return 'システムエラー';
    case FileStatusCode.COMPLETED:
      return '完了';
    case FileStatusCode.REG_CHECK_RESERVED:
      return '法規制チェック実施待ち';
    case FileStatusCode.REG_CHECKING:
      return '法規制チェック中';
    case FileStatusCode.REG_CHECK_ERROR:
      return '法規制チェックエラー';
    default:
      return '';
  }
}

export default FileStatusCode;
